var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyboardErgonomic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 42,
    viewBox: "0 0 140 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.78479 3.72546C3.93007 2.74479 4.77183 2.01855 5.76319 2.01855H133.536C134.527 2.01855 135.369 2.74479 135.514 3.72546L138.96 26.9797C139.139 28.1878 138.202 29.2728 136.981 29.2728H2.31813C1.09686 29.2728 0.160742 28.1878 0.339718 26.9797L3.78479 3.72546Z",
    fill: "#313248"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78479 1.7069C3.93007 0.726238 4.77183 0 5.76319 0H133.536C134.527 0 135.369 0.726239 135.514 1.7069L138.96 24.9611C139.139 26.1692 138.202 27.2542 136.981 27.2542H2.31813C1.09686 27.2542 0.160742 26.1692 0.339718 24.9611L3.78479 1.7069Z",
    fill: "#3E4054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M97.4088 25.2353L94.8853 2.52344H96.3994L98.9229 25.2353H97.4088Z",
    fill: "#2B2D43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.597 10.0938L119.111 10.5985L119.752 15.3932H128.7L129.205 16.9073H118.469L117.597 10.0938Z",
    fill: "#2B2D43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.299 31.7969H1.51367L6.56075 39.3675C56.5163 42.9267 84.3724 42.8288 133.747 39.3675L139.299 31.7969Z",
    fill: "#313248"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.299 30.7871H1.51367L6.56075 38.3577C56.5163 41.9169 84.3724 41.8191 133.747 38.3577L139.299 30.7871Z",
    fill: "#3E4054"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardErgonomic);
export default __webpack_public_path__ + "static/media/KeyboardErgonomic.45192357eff6e4a6577603874883597c.svg";
export { ForwardRef as ReactComponent };